import {
  EventNote,
  Spa,
  Science,
  Medication,
  CurrencyRupee
} from '@mui/icons-material';
import CountUp from 'react-countup';

const KPI_CARDS = ({ data, isDoctor }) => {
  const kpiData = [
    {
      icon: EventNote,
      color: '#3E7BFA',
      bg: '#EAF2FF',
      label: 'Doctor Consultations',
      value: data?.appointment ?? 0,
    },
    {
      icon: Spa,
      color: '#33A89F',
      bg: '#E5F7F5',
      label: 'Detox Programs',
      value: data?.solution ?? 0,
    },
    {
      icon: Science,
      color: '#7B6EF6',
      bg: '#EEE8FF',
      label: 'Medi Daycare Rituals',
      value: data?.service ?? 0,
    },
    {
      icon: Spa,
      color: '#33A89F',
      bg: '#E5F7F5',
      label: 'Detox Retreat',
      value: data?.detoxRetreat ?? 0,
    },
    {
      icon: Medication,
      color: '#4CAF50',
      bg: '#E8F8EC',
      label: 'Treatment',
      value: data?.treatment ?? 0,
    },
    ...(!isDoctor
      ? [
        {
          icon: CurrencyRupee,
          color: '#3E7BFA',
          bg: '#EAF2FF',
          label: 'Total Revenue',
          value:
            (data?.revenue ?? 0) + (data?.cashCount ?? 0),
          meta: [
            { label: 'Online', value: data?.revenue ?? 0 },
            { label: 'Cash', value: data?.cashCount ?? 0 },
          ],
        },
      ]
      : []),
  ];

  return (
    <div
      className="mb-4"
      style={{
        display: 'grid',
        gap: '16px',
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
      }}
    >
      {kpiData.map((item, index) => {
        const Icon = item.icon;

        return (
          <div
            key={index}
            style={{
              background: '#fff',
              borderRadius: '16px',
              border: '1px solid #E5E7EB',
              minHeight: '170px',
              transition: 'all 0.2s ease',
            }}
            className="hover-shadow"
          >
            <div
              style={{
                height: '100%',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              {/* Icon */}
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: 12,
                  background: item.bg,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 12,
                }}
              >
                <Icon sx={{ fontSize: 26, color: item.color }} />
              </div>

              {/* Value */}
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 600,
                  color: '#111827',
                  lineHeight: 1.2,
                }}
              >
                <CountUp end={item.value} duration={1.3} separator="," />
              </div>

              {/* Label */}
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  color: '#6B7280',
                  marginTop: 4,
                }}
              >
                {item.label}
              </div>

              {/* Meta (for Financial Summary only) */}
              {item.meta && (
                <div
                  style={{
                    display: 'flex',
                    gap: 12,
                    marginTop: 8,
                    fontSize: 11,
                    color: '#6B7280',
                  }}
                >
                  {item.meta.map((m, i) => (
                    <span key={i}>
                      {m.label}:{' '}
                      <strong style={{ color: '#374151' }}>
                        ₹<CountUp end={m.value} duration={1.1} separator="," />
                      </strong>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default KPI_CARDS;
